import type { BottomTabNavigationProp } from '@react-navigation/bottom-tabs';

import type { MainTabParamList } from './types';

export type MainTabNav = BottomTabNavigationProp<MainTabParamList>;

export type DrillTab = 'Home' | 'Spend' | 'Wealth' | 'Loan' | 'Grow';

export function navigateToSpend(
  navigation: MainTabNav,
  options?: { monthKey?: string },
) {
  const monthKey = options?.monthKey?.trim();
  navigation.navigate('Spend', {
    screen: 'SpendHome',
    params:
      monthKey && /^\d{4}-\d{2}$/.test(monthKey) ? { monthKey } : undefined,
  });
}

export function navigateToLoan(navigation: MainTabNav) {
  navigation.navigate('Loan');
}

export function navigateToWealth(navigation: MainTabNav) {
  navigation.navigate('Wealth');
}

export function navigateToHome(navigation: MainTabNav) {
  navigation.navigate('Home');
}

export function navigateToGrow(navigation: MainTabNav) {
  navigation.navigate('Grow');
}

export function navigateToDrillTab(
  navigation: MainTabNav,
  tab: DrillTab,
  options?: { monthKey?: string },
) {
  switch (tab) {
    case 'Spend':
      navigateToSpend(navigation, options);
      break;
    case 'Loan':
      navigateToLoan(navigation);
      break;
    case 'Wealth':
      navigateToWealth(navigation);
      break;
    case 'Grow':
      navigateToGrow(navigation);
      break;
    case 'Home':
      navigateToHome(navigation);
      break;
  }
}
